<template>
  <v-container fluid ma-0 pa-0 px-4 id="bucketnew-main">
    <Loading :isLoading="loading">
      <div class="fixed-header" :class="{ mobile: $vuetify.breakpoint.smAndDown }">
        <!-- if has summary fields add class 'with-summary' -->
        <v-layout align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate">
                  Overview
                </h2>
              </template>
              <span>Overview</span>
            </v-tooltip>
            <h4 class="pt-1 sub-header d-inline-block">Bucket Groups - <span class="font-weight-bold">2</span></h4>
            <h4 class="pt-1 sub-header d-inline-block pl-3">Buckets - <span class="font-weight-bold">2</span></h4>
          </v-flex>
          <v-spacer></v-spacer>
          <v-divider vertical></v-divider>
          <v-flex shrink fill-height class="action">
            <v-tooltip left color="secondary">
              <v-btn icon flat slot="activator" @click="createNewDialog = true">
                <v-icon color="success" size="24">add_circle</v-icon>
              </v-btn>
              <span>Create a new bucket/bucket group</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </div>
      <v-dialog v-model="createNewDialog" width="400">
        <v-card class="pa-4">
          <v-card-title class="ma-0 mb-2 pa-0">
            <h2 class="mb-2">What would you like to create?</h2>
          </v-card-title>
          <v-card-text class=" ma-0 pa-0">
            <v-btn class="ma-0 mr-1" color="success"><v-icon class="mr-2">add_circle</v-icon>New Bucket</v-btn>
            <v-btn class="ma-0 ml-1" color="success"><v-icon class="mr-2">add_circle</v-icon>New bucket Group</v-btn>
          </v-card-text>
          <v-card-actions class="ma-0 mt-3 pa-0">
            <v-btn @click="createNewDialog = false" color="error">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-layout wrap>
        <v-flex xs12 pt-1>
          <v-btn :ripple="false" flat class="ml-0 mb-2 search-button" v-on:click="bucketsToggled = !bucketsToggled">
            <v-icon color="secondary" class="mr-2 mt-0">{{ bucketsToggled ? "close" : "search" }}</v-icon>
            {{ bucketsToggled ? "Close search" : "Search" }}
          </v-btn>
          <v-slide-y-transition>
            <v-layout row wrap class="mt-0" v-if="bucketsToggled">
              <v-flex xs12 sm6 md4 pt-1 :class="{ 'pr-0 ': $vuetify.breakpoint.xsAndDown, 'pr-2': $vuetify.breakpoint.smAndUp }">
                <v-text-field box clearable class="cardcontainer-search-text pa-0 ma-0 body-1" v-model="searchTerm" label="Search" color="secondary" clear-icon="cancel">
                  <template slot="append">
                    <v-icon>search</v-icon>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 pt-1 :class="{ 'pl-0': $vuetify.breakpoint.xsAndDown, 'pl-2': $vuetify.breakpoint.smAndUp }">
                <v-select box clearable style="border-bottom:0 !important; " class="cardcontainer-order-select pa-0 ma-0 body-1" :items="sortableBy" v-model="orderSelection" label="Order by" color="secondary" clear-icon="cancel" append-icon="keyboard_arrow_down"> </v-select>
              </v-flex>
            </v-layout>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
      <v-layout row wrap fluid class="card-margin-fix">
        <v-flex xs12 sm6 md4 lg3 xl2 px-3 mb-2>
          <v-card color="cardBackground" class="bucket-lid rounded-3"></v-card>
          <v-card color="cardBackground" class="px-4 py-2 mb-2 rounded-3 bucket-group-tile">
            <v-card-title class="pa-0 pb-2 pt-1">
              <router-link class="no-link-style w-100" to="/">
                <v-flex xs12>
                  <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-1 pb-1 pr-3">Bucket Group name</h3>
                </v-flex>
                <v-flex xs12 pr-4 pt-0>
                  <h4 class="text-truncate">
                    <span class="primary-text body-1 opacity-54">3 Buckets</span>
                  </h4>
                </v-flex>
              </router-link>
            </v-card-title>
            <v-card-actions class="card-vert-menu">
              <v-menu nudge-top="30px" left offset-y origin="center center" transition="scale-transition">
                <v-btn flat icon dark slot="activator" class="ma-0 mr-0 pa-0" color="secondary" style="margin-top:calc(50% - 15px) !important; margin-left:-10px !important;">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list dense>
                  <v-list-tile>
                    <v-icon class="mr-2" color="secondary">bookmark</v-icon>
                    Bookmark this Bucket Group
                  </v-list-tile>
                  <v-list-tile to="/">
                    <v-icon class="mr-2" color="secondary">edit</v-icon>
                    Edit Bucket Group
                  </v-list-tile>
                  <v-list-tile color="error" @click="showDeleteBucketGroupDialog = true">
                    <v-icon class="mr-2" color="error">delete</v-icon>
                    Delete Bucket Group
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-card-actions>
            <v-dialog v-model="showDeleteBucketGroupDialog" max-width="500">
              <v-card class="pa-4">
                <v-card-title class="pa-0 pb-2">
                  <h2>Are you sure you want to delete this bucket group?</h2>
                </v-card-title>
                <v-card-text class="pa-0">
                  <p>This will delete this bucket group and you won't be able to get it back.</p>
                </v-card-text>
                <v-card-actions class="ma-0 pa-0 pt-1">
                  <v-btn color="error" @click="deleteBucketGroup()">Yes, delete this bucket group</v-btn>
                  <v-btn @click="showDeleteBucketGroupDialog = false" color="secondary">Cancel</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md4 lg3 xl2 px-3 mb-2>
          <v-card color="cardBackground" class="bucket-lid rounded-3"></v-card>
          <v-card color="cardBackground" class="px-4 py-2 mb-2 rounded-3">
            <v-card-title class="pa-0 pb-2 pt-1">
              <router-link class="no-link-style w-100" to="">
                <v-flex xs12 pr-4 pt-1>
                  <h4 class="text-truncate">
                    <span class="primary-text body-1 opacity-54">235 Templates</span>
                  </h4>
                </v-flex>
                <v-flex xs12>
                  <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-0 pb-1 pr-3">Bucket name</h3>
                </v-flex>
              </router-link>
            </v-card-title>
            <v-card-actions class="card-vert-menu">
              <v-menu nudge-top="30px" left offset-y origin="center center" transition="scale-transition">
                <v-btn flat icon dark slot="activator" class="ma-0 mr-0 pa-0" color="secondary" style="margin-top:calc(50% - 8px) !important; margin-left:-10px !important;">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list dense>
                  <v-list-tile> <v-icon class="mr-2" color="secondary">bookmark</v-icon>Bookmark this Bucket </v-list-tile>
                  <v-list-tile @click="showRunTasksDialog = true"> <v-icon class="mr-2" color="secondary">update</v-icon>Run tasks </v-list-tile>
                  <v-list-tile> <v-icon class="mr-2" color="secondary">vertical_align_bottom</v-icon>Export </v-list-tile>
                  <v-list-tile @click="setupBucket()"> <v-icon class="mr-2" color="secondary">edit</v-icon>Configure Bucket </v-list-tile>
                  <v-list-tile color="error" @click="showDeleteDialog = true"> <v-icon class="mr-2" color="error">delete</v-icon>Delete Bucket </v-list-tile>
                </v-list>
              </v-menu>
            </v-card-actions>
            <v-dialog v-model="showDeleteDialog" id="buckets-delete-dialog" width="500">
              <v-card class="pa-4">
                <v-card-title class="ma-0 mb-2 pa-0">
                  <h2>Delete Bucket</h2>
                </v-card-title>
                <v-card-text class="ma-0 mt-2 mb-1 pa-0">
                  <p>Are you sure you want to delete this bucket?</p>
                </v-card-text>
                <v-card-actions class="ma-0 mt-3 pa-0">
                  <v-btn @click="deleteBucket" id="bucket-delete-dialog-delete-btn" color="error">
                    Yes, delete this bucket
                  </v-btn>
                  <v-btn @click="showDeleteDialog = false" id="bucket-delete-dialog-cancel-btn" color="secondary">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <RunTasksDialog :showRunTasksDialog="showRunTasksDialog" v-on:tasks-dialog-closed="showRunTasksDialog = false"></RunTasksDialog>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md4 lg3 xl2 px-3 mb-2>
          <v-card color="cardBackground" class="bucket-lid rounded-3"></v-card>
          <v-card color="cardBackground" class="px-4 py-2 mb-2 rounded-3">
            <v-card-title class="pa-0 pb-2 pt-1">
              <router-link class="no-link-style w-100" to="">
                <v-flex xs12 pr-4 pt-1>
                  <h4 class="text-truncate">
                    <span class="primary-text body-1 opacity-54">235 Templates</span>
                  </h4>
                </v-flex>
                <v-flex xs12>
                  <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-0 pb-1 pr-3">Bucket name</h3>
                </v-flex>
              </router-link>
            </v-card-title>
            <v-card-actions class="card-vert-menu">
              <v-menu nudge-top="30px" left offset-y origin="center center" transition="scale-transition">
                <v-btn flat icon dark slot="activator" class="ma-0 mr-0 pa-0" color="secondary" style="margin-top:calc(50% - 8px) !important; margin-left:-10px !important;">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list dense>
                  <v-list-tile> <v-icon class="mr-2" color="secondary">bookmark</v-icon>Bookmark this Bucket </v-list-tile>
                  <v-list-tile @click="showRunTasksDialog = true"> <v-icon class="mr-2" color="secondary">update</v-icon>Run tasks </v-list-tile>
                  <v-list-tile> <v-icon class="mr-2" color="secondary">vertical_align_bottom</v-icon>Export </v-list-tile>
                  <v-list-tile @click="setupBucket()"> <v-icon class="mr-2" color="secondary">edit</v-icon>Configure Bucket </v-list-tile>
                  <v-list-tile color="error" @click="showDeleteDialog = true"> <v-icon class="mr-2" color="error">delete</v-icon>Delete Bucket </v-list-tile>
                </v-list>
              </v-menu>
            </v-card-actions>
            <v-dialog v-model="showDeleteDialog" id="buckets-delete-dialog" width="500">
              <v-card class="pa-4">
                <v-card-title class="ma-0 mb-2 pa-0">
                  <h2>Delete Bucket</h2>
                </v-card-title>
                <v-card-text class="ma-0 mt-2 mb-1 pa-0">
                  <p>Are you sure you want to delete this bucket?</p>
                </v-card-text>
                <v-card-actions class="ma-0 mt-3 pa-0">
                  <v-btn @click="deleteBucket" id="bucket-delete-dialog-delete-btn" color="error">
                    Yes, delete this bucket
                  </v-btn>
                  <v-btn @click="showDeleteDialog = false" id="bucket-delete-dialog-cancel-btn" color="secondary">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <RunTasksDialog :showRunTasksDialog="showRunTasksDialog" v-on:tasks-dialog-closed="showRunTasksDialog = false"></RunTasksDialog>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md4 lg3 xl2 px-3 mb-2>
          <v-card color="cardBackground" class="bucket-lid rounded-3"></v-card>
          <v-card color="cardBackground" class="px-4 py-2 mb-2 rounded-3 bucket-group-tile">
            <v-card-title class="pa-0 pb-2 pt-1">
              <router-link class="no-link-style w-100" to="/">
                <v-flex xs12>
                  <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-1 pb-1 pr-3">Bucket Group name</h3>
                </v-flex>
                <v-flex xs12 pr-4 pt-0>
                  <h4 class="text-truncate">
                    <span class="primary-text body-1 opacity-54">3 Buckets</span>
                  </h4>
                </v-flex>
              </router-link>
            </v-card-title>
            <v-card-actions class="card-vert-menu">
              <v-menu nudge-top="30px" left offset-y origin="center center" transition="scale-transition">
                <v-btn flat icon dark slot="activator" class="ma-0 mr-0 pa-0" color="secondary" style="margin-top:calc(50% - 15px) !important; margin-left:-10px !important;">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list dense>
                  <v-list-tile>
                    <v-icon class="mr-2" color="secondary">bookmark</v-icon>
                    Bookmark this Bucket Group
                  </v-list-tile>
                  <v-list-tile to="/">
                    <v-icon class="mr-2" color="secondary">edit</v-icon>
                    Edit Bucket Group
                  </v-list-tile>
                  <v-list-tile color="error" @click="showDeleteBucketGroupDialog = true">
                    <v-icon class="mr-2" color="error">delete</v-icon>
                    Delete Bucket Group
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-card-actions>
            <v-dialog v-model="showDeleteBucketGroupDialog" max-width="500">
              <v-card class="pa-4">
                <v-card-title class="pa-0 pb-2">
                  <h2>Are you sure you want to delete this bucket group?</h2>
                </v-card-title>
                <v-card-text class="pa-0">
                  <p>This will delete this bucket group and you won't be able to get it back.</p>
                </v-card-text>
                <v-card-actions class="ma-0 pa-0 pt-1">
                  <v-btn color="error" @click="deleteBucketGroup()">Yes, delete this bucket group</v-btn>
                  <v-btn @click="showDeleteBucketGroupDialog = false" color="secondary">Cancel</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </v-flex>
      </v-layout>
    </Loading>
  </v-container>
</template>

<script>
import "@/assets/styles/styles.css"
import Loading from "@/components/shared/Loading.vue"
import RunTasksDialog from "@/components/buckets/bucket-elements/RunTasksDialog"

export default {
  name: "buckets",
  components: { Loading, RunTasksDialog },
  data: () => ({
    createNewDialog: false,
    showDeleteBucketGroupDialog: false,
    showDeleteDialog: false,
    bucketsToggled: "",
    showRunTasksDialog: false,
    orderByOptions: [{ text: "Last Login", value: "updated_at" }, { text: "Date Created", value: "created_at" }, { text: "Name", value: "displayName" }],
    searchByOptions: ["displayName", "id"],
    searchTerm: "",
    orderType: "",
    loading: false,
  }),
  methods: {
    deleteBucket() {
      this.showDeleteDialog = false
      this.$store.dispatch("deleteBucket", this.bucket.id)
    },
  },
}
</script>
